// ===========================================
// "Next late fee" preview for one invoice (#372 slice C, plan C4.1)
// ===========================================
// The key sits UNDER `['invoices']` on purpose: every write that changes the answer already
// invalidates that prefix (waive a fee, hold or release reminders, set or clear a family
// exemption, record, amend or delete a payment), so the line refreshes with no extra wiring.
// It is a literal rather than `invoiceKeys` so a page test that replaces `useInvoices` wholesale
// does not take this hook down with it.

import { useQuery } from '@tanstack/react-query';
import { adminInvoicesApi } from '../api/invoices.api';

/** Prefix of every invoice's preview: settings and step changes invalidate it. */
export const LATE_FEE_PREVIEW_PREFIX = ['invoices', 'late-fee-preview'] as const;

export const lateFeePreviewKey = (invoiceId: string) => ['invoices', 'late-fee-preview', invoiceId] as const;

export function useLateFeePreview(invoiceId: string, enabled: boolean) {
  return useQuery({
    queryKey: lateFeePreviewKey(invoiceId),
    queryFn: () => adminInvoicesApi.getLateFeePreview(invoiceId),
    enabled: enabled && !!invoiceId,
  });
}
